module.exports = __webpack_public_path__ + "img/erp-logos_0007_tradegecko.bd2050d5.jpg";